<div class="cc-container">
    <div class="cc-header">
        <h3 class="d-flex">Cost Contribution &nbsp;
            <div *ngIf="level==='factory'" [style.display]="level==='factory' ? '' : 'none'" [popover]="viewMorePopOver"
                triggers="mouseenter:mouseleave" container="body" placement="bottom"><img
                    src="../../../assets/images/icn-info.svg" alt=""></div>
            <div *ngIf="level==='line'" [style.display]="level==='line' ? '' : 'none'" [popover]="viewMorePopOver1"
                triggers="mouseenter:mouseleave" container="body" placement="bottom"><img
                    src="../../../assets/images/icn-info.svg" alt=""></div>
        </h3>
        <mat-icon aria-hidden="false" aria-label="close icon" mat-dialog-close>close</mat-icon>
    </div>
    <div class="cc-body">
        <div class="cc-selection">
            <mat-radio-group (change)="onChange($event)" class="cc-mat-radio" [disabled]="isLoading">
                <mat-radio-button class="cc-mat-radio-option" value="Line"
                    [checked]="selectedCostContributionItem === 'Line'" *ngIf="level === 'factory'">Line
                </mat-radio-button>
                <mat-radio-button class="cc-mat-radio-option" value="Sku"
                    [checked]="selectedCostContributionItem === 'Sku'">SKU</mat-radio-button>
                <mat-radio-button class="cc-mat-radio-option" value="Bom"
                    [checked]="selectedCostContributionItem === 'Bom'">BoM</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="cc-split" [style.opacity]="!isLoading ? '1' : '0.3'">
            <div class="cc-loading" *ngIf="isLoading">
                <div>Loading...</div>
            </div>
            <div class="cc-graph-container">
                <div #graphDiv class="donut" id="graphDiv"></div>
                <div class="cc-graph-details">
                    <div class="cc-graph-details-title">{{graphHoverTitleT}}</div>
                    <div class="cc-graph-details-cost" *ngIf="graphHoverCostT" innerHTML="{{graphHoverCostT | cost}}">
                    </div>
                    <div class="cc-graph-details-percentage">{{graphHoverPercentageT}}</div>
                </div>
            </div>
            <div class="cc-list-container">
                <div class="cc-search-container">
                    <input class="cc-text-box" (keyup)="search($event.target.value)" matInput
                        [placeholder]="searchPlaceHolder" autocomplete="off" [value]="searchKeyword">
                </div>
                <div class="cc-list" (scroll)="onScroll($event)" (mouseleave)="setGraphTitle()">
                    <div class="cc-item"
                        [class.no-cursor]="this.level === 'factory' && this.selectedCostContributionItem === 'Sku' || this.selectedCostContributionItem === 'Bom'"
                        *ngFor="let item of filteredCostContributionItems; let i = index"
                        [popover]="(selectedCostContributionItem !== 'Line') ? item.id : ''"
                        triggers="mouseenter:mouseleave" container="body" placement="top" [adaptivePosition]="false"
                        (mouseover)="setGraphTitle(item)" (focus)="setGraphTitle(item)"
                        (keydown.enter)="onClickCostContributionItem(item)"
                        (keydown.space)="onClickCostContributionItem(item)" (click)="onClickCostContributionItem(item)">
                        <div class="cc-left">
                            <div class="cc-color" [style.background-color]="item?.color"></div>
                            <div class="cc-name">
                                {{ (item?.name.length > 20)? (item?.name | slice:0:20)+'...' : (item?.name)}}
                            </div>
                        </div>
                        <div class="cc-right">
                            <div class="cc-percentage">{{item.percentage}}%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #viewMorePopOver>
    <div class="mb-15"> Waste Cost Contribution split at Line, SKU or BoM at the Factory
        level
        for the selected time period</div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost Contribution =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                total waste cost generated by the selected Line/SKU/BoM

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost of the factory for the selected period
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>
<ng-template #viewMorePopOver1>
    <div class="mb-15-pop"> Waste Cost Contribution split at SKU or BoM at the Line level for the selected time period
    </div>

    <div class="tooltip-formula-pop">
        <div class="tooltip-left-pop">
            Cost Contribution =
        </div>
        <div class="tooltip-center-pop">
            <div class="tooltip-center-top-pop">
                total waste cost generated by the selected SKU/BoM

            </div>
            <hr class="tooltip-center-middle-pop">
            <div class="tooltip-center-bottom-pop">
                total waste cost of the Line for the selected period
            </div>

        </div>
        <div class="tooltip-right-pop">
            * 100
        </div>
    </div>

</ng-template>